module.exports = __webpack_public_path__ + "img/SmallBlueOval.0444ba0f.svg";